
const industryTypes = () => [ //TODO: dynamic list from query
    { id: 'Retail', name: 'Retail' },
    { id: 'Manufacturer', name: 'Manufacturer' },
    { id: 'Beauty & Personal Care', name: 'Beauty & Personal Care' },
    { id: 'Healthcare', name: 'Healthcare' },
    { id: 'Services', name: 'Services' },
    { id: 'Entertainment', name: 'Entertainment' },
    { id: 'Restaurant', name: 'Restaurant' },
    { id: 'Medical', name: 'Medical' },
    { id: 'Education', name: 'Education' },
]


export default industryTypes